import React from 'react'
import { Link } from 'react-router-dom';
import Icon1 from '../../assets/img/shape/shape-3.png';
import WhoWeAre from '../../assets/img/who_we_are.png';
import { LuArrowUpDown } from 'react-icons/lu'
import { FaFileInvoice } from "react-icons/fa6";
import empowerImg from '../../assets/img/empower.png'
import { SearchNormal1 } from 'iconsax-react';
import { Helmet } from "react-helmet-async";
import CareerSection from '../../components/Careers/CareerSection';

const coreValues = [
  {
    title: "INCLUSION",
    description: "At Cardplot, inclusion fuels everything we do. We create room for every voice, and through collaboration, we build solutions that work for all.",
    iconClass: "fa-solid fa-users"
  },
  {
    title: "CONNECTIVITY",
    description: "Connectivity at Cardplot goes beyond tech. It is about staying locally relevant and creating real community impact through solutions built with purpose for everyday Africans.",
    iconClass: "fa-solid fa-network-wired"
  },
  {
    title: "EXCELLENCE",
    description: "Excellence drives every aspect of Cardplot's operations, features, and experience. We proudly and relentlessly combine precision with passion.",
    iconClass: "fa-solid fa-star"
  },
  {
    title: "COMPATIBILITY",
    description: "Cardplot integrates seamlessly with how Africa transacts by bridging mobile-first experiences, real-time access, and next-gen financial tools for the continent’s bold innovators.",
    iconClass: "fa-solid fa-plug"
  },
  {
    title: "TRANSPARENCY",
    description: "We don’t just move money, we move trust by safeguarding your transactions through unshakable security, relentless accountability, and steadfast dependability.",
    iconClass: "fa-solid fa-lock"
  },
  {
    title: "PROFESSIONALISM",
    description: "We measure strict adherence to best practices, meticulous attention to detail, and commitment to ethical standards. We ensure reliable, high-calibre service at every touchpoint.",
    iconClass: "fa-solid fa-briefcase"
  }
];

function Career() {
  return (
    <>
      <Helmet>
        <title>Career | Cardplot</title>
      </Helmet>
      <section className='breadcrumb__section bg-overlay'>
        <div className="container">
          <div className='row'>
            <div className='col-md-12'>
              <div className="breadcrumb__title__head">
                <ol className="breadcrumb">
                  <li className="active"><img src={Icon1} style={{ width: '25px', height: '25px' }} alt="" /></li>
                </ol>
                <h2 className='breadcrumb__title'> CAREERS </h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="breadcrumb__text">
                <h3 className='breadcrumb__text__head heading'>Join the Cardplot Team!</h3>
                <p className='breadcrumb__text__content'>At Cardplot, we’re revolutionizing payments across Africa, empowering businesses and individuals with seamless, secure, and innovative financial solutions.</p>
              </div>
              <div className='d-flex gap-3 justify-content-center align-items-center' style={{ paddingTop: '40px' }}>
                <Link to='' className='btn btn__primary'>Explore Careers</Link>
                <Link to='/contact' className='btn btn__outline_primary text__dark'>Contact us</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='career__section padding__tb__100'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-12'>
              <h2 className='career__section__heading'>Why Work With Us?</h2>
            </div>
          </div>
          <div className="row">
            {coreValues.map((value, index) => (
              <div key={index} className="col-12 col-md-4 mb-4">
                <div className="our__core__values__item">
                  <div className="our__core__values__icon mb-3">
                    <i className={value.iconClass}></i>
                  </div>
                  <h3 className="our__core__values__subtitle">{value.title}</h3>
                  <p className="our__core__values__text">{value.description}</p>
                </div>
              </div>
            ))}
          </div>
          <div className='row padding__tb__100 align-items-center'>
            <div className='col-12 col-lg-6 mb-4'>
              <h2 className='who__we__are__heading'>Who We’re Looking For</h2>
              <p className='who__we__are__content'>
                Passionate, talented, and driven individuals who thrive on solving complex challenges, think big, and share our vision of a connected Africa.
              </p>
            </div>
            <div className='col-12 col-lg-6 mb-4'>
              <div className='who__we__are__image text-lg-end'>
                <img src={WhoWeAre} alt='Who We Are'  className='img-fluid'/>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section><CareerSection /></section>

      <section className='empower_your_trade career_overlay'>
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-lg-6">
              <div className="empower__title">
                <h2>Ready to simplify your payments?</h2>
                <p>Simplify Your Exchange, Empower Your Trade</p>
                <div className='d-flex gap-3' style={{ paddingTop: '60px' }}>
                  <Link to='' className='btn btn__primary'>Explore Careers</Link>
                  <Link to='' className='btn btn__outline_primary career_overlay'>Contact us</Link>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="empower__img">
                <img src={empowerImg} className='img-fluid' alt="empower" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Career 